import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

export interface AppSetting {
  key: string;
  category: string;
  value: string;
  value_type: string;
  label: string;
  description: string | null;
  min_value: number | null;
  max_value: number | null;
  unit: string | null;
  sort_order: number;
  updated_at: string | null;
  updated_by: string | null;
}

export function useAppSettings(category?: string) {
  return useQuery<AppSetting[]>({
    queryKey: ["app-settings", category ?? "all"],
    queryFn: () =>
      api
        .get("/app-settings/", { params: category ? { category } : {} })
        .then((r) => r.data),
    staleTime: 30_000,
  });
}

export function useUpdateAppSetting() {
  const qc = useQueryClient();
  return useMutation<AppSetting, Error, { key: string; value: string }>({
    mutationFn: ({ key, value }) =>
      api.put(`/app-settings/${key}`, { value }).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["app-settings"] });
    },
  });
}
